<template>
  <div>
    <button @click="start">导出</button>
    <div id="pic" v-if="render === ''">
      <div class="top">
        <!--        <div class="meng"></div>-->
        <!--        <img src="./lsp/Pro-tou1.png" alt="" class="topTou1" />-->
        <!--        <img src="./lsp/Pro-tou2.png" alt="" class="topTou2" />-->
        <img class="img" src="../assets/iap.png" />
        <div crossorigin="anonymous" class="background" :style="`background-image:url('${pro.img}')`" />
      </div>
      <div class="bottom">
        <!-- <img src="./lsp/yinying.png" style="position: absolute;left: -20px;top: -20px;" /> -->
        <img src="./lsp/yinhao-standard.png" class="shangyin" />
        <div class="direction" :style="{ fontSize: dirFont + 'px' }">{{ pro.direction }}</div>
        <div :style="{ fontSize: dirFont + 'px' }" id="direction" class="direction"
          style="max-width: 750px;visibility: hidden;position: absolute">{{ pro.direction }}</div>
        <div class="heng" :style="{ top: linesOfDer * 30 + 100 + 'px' }"></div>
        <img class="tou" crossorigin="anonymous" :src="pro.professor.avatar" />
        <div class="teacher">
          PROF.
          <br />
          <div :style="{ fontSize: fontSize + 'px' }"
            style="font-family: inherit;display: inline-block;width: 250px;color:#555555">
            {{ pro.professor.lastName.toUpperCase() }}
          </div>
          <div :style="{ fontSize: fontSize + 'px' }" id="mirror"
            style="position: absolute;visibility: hidden;font-family: inherit">
            {{ pro.professor.lastName.toUpperCase() }}
          </div>
        </div>
        <div class="school">
          <div :style="{ fontSize: schoolFont + 'px' }" style="display: inline-block">
            {{ pro.professor.school }}
          </div>
          <div :style="{ fontSize: schoolFont + 'px' }" id="school" style="visibility: hidden;position: absolute">
            {{ pro.professor.school }}
          </div>
          <br />
          {{ pro.professor.position }}
        </div>
        <div id="qrcode" />
        <img class="psimg" src="./lsp/ps-pro.png" />
        <img src="./lsp/yinhao-standard.png" class="xiayin" />
      </div>
    </div>
    <img :src="render" v-else style="width:100%" />
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'

export default {
  name: 'litepage',
  data() {
    return {
      uuid: '',
      name: 'Green',
      school: '',
      position: '',
      total: 0,
      num: 0,
      OSS: process.env.VUE_APP_OSS,
      direction: '',
      render: '',
      file: '',
      tou: '',
      img: '', // 海报背景图地址
      linesOfDer: 1,
      firstName: '',
      professor: '',
      tags: '',
      fontSize: 36,
      schoolFont: 28,
      dirFont: 28,
      pro: { professor: { lastName: '' } },
      proes: [['7976224', 'Paul', 'Goldin', '宾夕法尼亚大学', '终身教授', '历史学', ['人类学', '民俗学', '中国哲学', '中国古代史', '民族学']], ['3691225', 'Dario', 'Alfe', '伦敦大学学院', '终身教授', '地质学', ['物理学', '地球物理', '工程物理学']], ['9862226', 'Mellissa', 'Withers', '南加州大学', '终身教授', '公共管理', ['公共卫生', '公共政策']], ['7111227', 'Justin', 'Stebbing', '帝国理工学院', '终身教授', '生物学', ['肿瘤生物学', '细胞生物学', '免疫生物学', '遗传生物学']], ['7946228', 'Peter', 'Schroeder', '伦敦大学学院', '终身教授', '哲学', ['近代西方哲学', '世界史']], ['5231229', 'Gary', 'Royle', '伦敦大学学院', '终身教授', '医学', ['肿瘤生物学', '细胞生物学', '临床医学', '病理学']], ['2009230', 'Ramin', 'Ramezani', '加州大学洛杉矶分校', '教授', '计算机科学', ['数据科学', '人工智能', '机器学习', '计算机视觉', '自动驾驶', '传感器', '生物医学工程']], ['8210231', 'Diane', 'Purkiss', '牛津大学', '终身教授', '文学', ['英文文学', '西方近代史']], ['1433232', 'Richard', 'Palin', '牛津大学', '终身教授', '地质学', ['地球化学', '地球物理', '矿物学', '构造地质学', '空间地质学', '地质工程']], ['353233', 'Enrico', 'Palandri', '伦敦大学学院', '终身教授', '文学', ['翻译学', '英文文学', '历史学']], ['1812234', 'KoonGee', 'Neoh', '新加坡国立大学', '荣休教授', '生物学', ['生命科学', '细胞生物学', '分子生物学']], ['3643235', 'Jamie', 'Lorimer', '牛津大学', '终身教授', '环境科学', ['海洋科学', '大气科学', '气象学', '地理学']], ['9699236', 'Steven', 'Lipkin', '康奈尔大学', '终身教授', '生物学', ['生命科学', '肿瘤生物学', '细胞生物学', '遗传生物学']], ['130237', 'Kourosh', 'Khoshelham', '墨尔本大学', '终身教授', '计算机科学', ['深度学习', '计算机视觉', '遥感', '导航定位']], ['163238', 'Slava', 'Kalyuga', '新南威尔士大学', '荣休教授', '教育学', ['认知心理学', '语言学', '二语习得']], ['1030239', 'Hicham', 'Idriss', '伦敦大学学院', '荣誉教授', '化学工程', ['生物工程', '化学', '纳米技术', '生物化工', '催化工程', '化学计量学']], ['6844240', 'Naira', 'Hovakimyan', '伊利诺伊大学香槟分校', '终身教授', '控制工程', ['数学建模', '控制系统', '系统工程', '航空航天工程']], ['7349241', 'Anthony', 'Bull', '帝国理工学院', '终身教授', '生物学', ['临床医学', '生物医学工程', '运动康复']], ['7112242', 'Alexei', 'Chekhlov', '哥伦比亚大学', '教授', '金融学', ['数学建模', '经济学', '金融衍生品', '商业分析']], ['4793243', 'Susana', 'Lopez-Querol', '伦敦大学学院', '终身教授', '电气工程', ['计算数学', '系统工程', '自动化', '电机设计', '能源与动力', '新能源']], ['891244', 'Martyn', 'McLachlan', '帝国理工学院', '终身教授', '材料学', ['金属材料', '纳米材料', '新型功能材料', '半导体技术']], ['2877245', 'Lucy', 'Green', '伦敦大学学院', '荣休教授', '艺术学', ['音乐学', '艺术史', '艺术管理']], ['1789246', 'Gerhard', 'Klimeck', '普渡大学', '终身教授', '电子信息工程', ['通信工程', '微电子', '电子电路', '半导体技术']], ['7699247', 'Chirag', 'Shah', '华盛顿大学', '教授', '计算机科学', ['数据科学', '数据挖掘', '人工智能', '推荐系统', '机器学习', '人机交互', '信息学']], ['2808248', 'Zoltan', 'Nagy', '普渡大学', '终身教授', '药学', ['药物化学', '药剂学', '化学工程', '化学工艺', '过程工程']], ['6421249', 'Kevin', 'Njabo', '加州大学洛杉矶分校', '教授', '生态学', ['野生动物保护', '森林植被保护', '人文生态学', '大气科学', '地理学']], ['8665250', 'Mario', 'Campanelli', '伦敦大学学院', '终身教授', '物理学', ['实验物理', '量子物理', '高能物理']], ['1580251', 'Anh', 'Tran', '卡斯商学院', '终身教授', '金融学', ['金融工程', '公司金融', '资产定价', '商业分析']]]
    }
  },
  methods: {
    async start() {
      for (let i = 0; i < this.proes.length; i++) {
        const pro = this.proes[i]
        setTimeout(() => {
          Object.assign(this.pro, { uuid: pro[0], professor: { firstName: pro[1], lastName: pro[2], school: pro[3], position: pro[4], avatar: `./avatar/${i + 1}. ${pro[1]} ${pro[2]}.png` }, tags: [pro[5]].concat(pro[6]), img: `./poster/${i + 1}. ${pro[1]} ${pro[2]}.jpg` })
          this.set()
          this.$nextTick(() => {
            this.initFontSize()
            setTimeout(() => {
              this.exportx()
            }, 0)
          })

          this.fontSize = 36
          this.schoolFont = 28
          this.dirFont = 28
        }, 4000 * i)
      }
    },
    initDover() {
      let d = this.pro.tags
      if (d.length >= 4) {
        this.linesOfDer = 2
        let len = []
        let max = 0
        for (let i of d) {
          max += i.length
          len.push(max)
        }
        let mid = Math.floor(max / 2)
        let key
        for (let i = 0; i < d.length; i++) {
          if (len[i] >= mid) {
            let a = Math.abs((max - len[i] + (d.length - i - 2)) - (len[i] + i))
            let b = Math.abs((max - len[i + 1] + (d.length - i - 3)) - (len[i] + i + 1))
            if (a >= b) {
              key = i + 1
            } else {
              key = i
            }
            break
          }
        }
        let res = ''
        for (let i = 0; i < d.length; i++) {
          res += d[i] + (i === key || i === d.length - 1 ? '\n' : ' | ')
        }
        this.pro.direction = res
        // this.direction = x[0] + ' | ' + x[1] + '\n' + x[2] + ' | ' + x[3]
      } else {
        this.linesOfDer = 1
        let res = ''
        for (let i = 0; i < d.length; i++) {
          res += d[i] + (i === d.length - 1 ? '\n' : ' | ')
        }
        this.pro.direction = res
      }
    },
    initFontSize() {
      let key, key2, key3
      let _this = this
      async function initmirror() {
        for (let i = 0; i < 20; i++) {
          await _this.$nextTick(() => {
            key = document.getElementById('mirror').offsetWidth
            if (key > 250) {
              _this.fontSize -= 1
            }
          })
          if (key <= 250) {
            break
          }
        }
      }

      initmirror()
      async function initschool() {
        for (let i = 0; i < 20; i++) {
          await _this.$nextTick(() => {
            key2 = document.getElementById('school').offsetWidth
            if (key2 > 250) {
              _this.schoolFont -= 1
            }
          })
          if (key2 <= 250) {
            break
          }
        }
      }

      initschool()
      async function initdirection() {
        for (let i = 0; i < 16; i++) {
          console.log((i))
          await _this.$nextTick(() => {
            key3 = document.getElementById('direction').offsetWidth
            if (key3 > 475) {
              _this.dirFont -= 1
            }
          })
          if (key3 <= 475) {
            break
          }
        }
      }

      initdirection()
    },
    set() {
      let origin = 'https://p.eliteqihang.com/pro/'
      let qrcode = `${origin}${this.pro.uuid}`
      this.linesOfDer = 1
      this.initDover()
      document.getElementById('qrcode').innerHTML = ''
      // eslint-disable-next-line
      new QRCode('qrcode', {
        text: qrcode,
        width: 100, // 图像宽度
        height: 100, // 图像高度
        colorDark: '#000000', // 前景色
        colorLight: '#ffffff', // 背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    exportx() {
      this.$nextTick(() => {
        document.body.style.width = '2024px'

        html2canvas(document.querySelector('#pic'), {
          useCORS: true,
          scrollY: 0,
          height: 1624
        }).then(canvas => {
          document.body.style.width = 'unset'
          let a = document.createElement('a')
          a.href = canvas.toDataURL('image/png', 0.9)
          a.setAttribute('target', '_blank')
          a.download = `${this.pro.professor.firstName} ${this.pro.professor.lastName}.png`
          a.click()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  font-family: PFBD;
}

#pic {
  width: 375 * 2px;
  height: 812 * 2px;
  position: relative;

  .img {
    width: 375 * 2px;
    height: 392 * 2px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .background {
    width: 375 * 2px;
    height: 392 * 2px;
    top: 0;
    z-index: 0;
    background-position: top;
    background-size: cover;
    position: absolute;
  }

  .meng {
    width: 375 * 2px;
    height: 392 * 2px;
    position: absolute;
    top: 0 * 2px;
    z-index: 1;
    background: rgba(#000000, 0.65);
  }

  .xian {
    width: 35 * 2px;
    left: 30 * 2px;
    border-top: 2 * 2px solid #fff;
    position: absolute;
    top: 70 * 2px;
  }

  .top {
    width: 375 * 2px;
    height: 392 * 2px;
    position: relative;

    .topTou1 {
      width: 102 * 2px;
      position: absolute;
      top: 38 * 2px;
      left: 50 * 2px;
      z-index: 2;
    }

    .topTou2 {
      width: 275 * 2px;
      position: absolute;
      top: 95 * 2px;
      left: 50 * 2px;
      z-index: 2;
    }
  }

  .bottom {
    width: 375 * 2px;
    height: 437 * 2px;
    position: relative;
    z-index: 100;

    .shangyin {
      top: 40 * 2px;
      left: 50 * 2px;
      position: absolute;
    }

    .tou {
      position: absolute;
      width: 120 * 2px;
      height: 120 * 2px;
      left: 50 * 2px;
      top: 120 * 2px;
      border-radius: 50%;
      background-color: white;
    }

    .direction {
      position: absolute;
      right: 50 * 2px;
      top: 40 * 2px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 14 * 2px;
      line-height: 18 * 2px;
      text-align: right;
      color: #d7af87;
      max-width: 475px;
      white-space: pre-line;
    }

    .heng {
      position: absolute;
      right: 50 * 2px;
      top: 80 * 2px;
      width: 25 * 2px;
      border-top: 2 * 2px solid #d7af87;
    }

    .teacher {
      position: absolute;
      left: 200 * 2px;
      top: 122 * 2px;
      width: 130 * 2px;
      font-family: LemonMilkbold;
      font-style: normal;
      font-weight: 600;
      font-size: 18 * 2px;
      line-height: 25 * 2px;
      //letter-spacing: 0.05em;
      color: #d7af87;
      text-align: left;
    }

    .school {
      position: absolute;
      left: 200 * 2px;
      top: 172 * 2px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 600;
      font-size: 14 * 2px;
      text-align: left;
      line-height: 19.6 * 2px;
      letter-spacing: 0.05em;
      color: #555555;

      div {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 14 * 2px;
        line-height: 19.6 * 2px;
        letter-spacing: 0.05em;
        color: #555555;
      }
    }

    #qrcode {
      position: absolute;
      right: 45 * 2px;
      bottom: 40 * 2px;
    }

    .ps {
      position: absolute;
      left: 90 * 2px;
      bottom: 45 * 2px;
      font-family: PFBD;
      font-style: normal;
      font-weight: 600;
      font-size: 8 * 2px;
      display: flex;
      align-items: center;
      color: #555555;
    }

    .psimg {
      position: absolute;
      left: 50 * 2px;
      bottom: 40 * 2px;
      width: 213 * 2px;
    }

    .xiayin {
      position: absolute;
      right: 50 * 2px;
      bottom: 134 * 2px;
      transform: rotate(-180deg);
    }
  }
}
</style>
